import { Item } from '@/typings/entity/item';
import { Restaurant } from '@/typings/entity/restaurant';

export function itemImageUrl(item: Item, restaurant: Restaurant): string {
  return `/images/items/${restaurant.brandId}/${item.id}.jpg`;
}
